<template>
    <div>
        <div class="header">
            {{ $vuetify.lang.t('$vuetify.pin.pinMamagement') }}
        </div>
        <div>
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.pin.searchBy')"
                        solo
                        height="40"
                        @keyup.enter="getEmployeesPinPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="getEmployeesPinPagination()"
                        color="primary"
                        outlined
                        height="40">
                        {{ $vuetify.lang.t('$vuetify.pin.search') }}
                    </v-btn>
                </div>
            </div>
        </div>

        <reset-pin-form
            ref="resetPinForm"
            :updateEmployeeId="updateEmployeeId"
            @success-updated="getEmployeesPinPagination" />

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalEmployees"
                :items="employees"
                :loading="loading">
                <template v-slot:[`item.pin`]="{ item }">
                    <v-icon
                        :class="`has-pin-${item.pin}`"
                        class="mr-2">
                        enhanced_encryption
                    </v-icon>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-btn
                            class="primary"
                            @click="openResetForm(item.id)"
                            :disabled="!item.pin">{{ $vuetify.lang.t('$vuetify.pin.reset') }}</v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import ResetPinForm from '../components/modal/ResetPinForm.vue'
export default {
    name: 'Pin',

    components: {
        ResetPinForm
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.pin.name'), value: 'fullname', width: '30%' },
                { text: this.$vuetify.lang.t('$vuetify.pin.employeeNo'), value: 'employee_no', width: '30%' },
                { text: this.$vuetify.lang.t('$vuetify.pin.pinStatus'), value: 'pin', width: '20%' },
                { text: '', value: 'action', sortable: false, width: '20%' }
            ]
        }
    },
    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            employees: [],
            totalEmployees: 0,
            loading: false,
            updateEmployeeId: null,
            branchId: null
        }
    },

    methods: {
        async getEmployeesPinPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `employees/pin?branch=${this.branchId}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.employeeStatus) {
                url += `&status=${this.employeeStatus}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.employees = res.data.data
                this.totalEmployees = res.data.total
                this.loading = false
            }
        },

        async getBranch () {
            this.branchId = localStorage.getItem('currentBranchId')
            if (this.branchId) {
                await this.getEmployeesPinPagination()
            }
        },

        openResetForm (id) {
            this.$refs.resetPinForm.openModal()
            this.updateEmployeeId = id
        }
    },

    async mounted () {
        await this.getBranch()
    },

    watch: {
        options: {
            async handler () {
                if (this.branchId) {
                    await this.getEmployeesPinPagination()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

::v-deep .content-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;

    .v-data-table__wrapper {
        border-top-left-radius: 15px !important;
        border-top-right-radius: 15px !important;

        thead.v-data-table-header {
            background-color: #6c6c6c;

            th {
                height: 46px;
                max-width: 1px;
                color: #ffffff;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            span, i {
                font-weight: normal;
                font-size: 15px !important;
                color: white !important;
            }

            i {
                padding: 5px;
            }
        }

        tbody td {
            height: 55px;
            font-size: 16px;
            max-width: 1px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}

.action {
    display: flex;
}

.search-container {
    display: flex;
}

.has-pin-true {
    color: #43A047;
}

.has-pin-false {
    color: #ff544a;
}

</style>
